@if (!match.profile.disableRoundFlyby) {
  <app-flyby #roundFlyby>
    <div class="round-flyby">{{match.round.currentName | async | uppercase}}</div>
  </app-flyby>
}

@if (match.teams.optionalEnabled) {
  <app-optional-score />
}
<img class="logo" [class.logo__shadow]="match.profile.logoShadow" alt="logo" src="/assets/logos/{{match.logo}}">
<app-score />
@if (match.round.enabled) {
  <app-round-names/>
}
